import { useEffect, useState } from 'react';
import { authTokenStore } from '@weareopenr/authkit';

export const VENUE_ACCESS_MANAGEMENT_FLAG = 'venue-access-management';

// Mirrors the API authoriser's reading of the WorkOS feature_flags claim:
// an absent, empty, or unreadable claim means every flag is off.
const decodeFeatureFlags = (token: string): string[] => {
  try {
    const payload = token.split('.')[1];
    const normalised = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalised + '='.repeat((4 - (normalised.length % 4)) % 4);
    const claims: unknown = JSON.parse(window.atob(padded));
    const flags = (claims as { feature_flags?: unknown }).feature_flags;
    if (!Array.isArray(flags)) return [];
    return flags.filter((flag): flag is string => typeof flag === 'string');
  } catch {
    return [];
  }
};

export const useFeatureFlags = () => {
  const [flags, setFlags] = useState<string[]>([]);

  useEffect(() => {
    let isMounted = true;
    authTokenStore
      .getAccessToken()
      .then((token) => {
        if (isMounted) setFlags(decodeFeatureFlags(token));
      })
      .catch(() => {
        if (isMounted) setFlags([]);
      });
    return () => {
      isMounted = false;
    };
  }, []);

  const hasFeatureFlag = (flag: string): boolean => flags.includes(flag);

  return {
    hasFeatureFlag,
    venueAccessManagement: hasFeatureFlag(VENUE_ACCESS_MANAGEMENT_FLAG),
  };
};
